export default __webpack_public_path__ + "static/ProductGraphic4-2ca0392561a955e81444249f1cca9726.png";